import Vue from 'vue'
import Vuex from 'vuex'

import table from '@/store/modules/table'

import opUser from '@/store/modules/op_user'
import agent from '@/store/modules/agent'
import user from '@/store/modules/user'
import device from '@/store/modules/device'
import bill from '@/store/modules/bill'
import bank from '@/store/modules/bank'
import factory from '@/store/modules/factory'
import app from '@/store/modules/app'
import store from '@/store/modules/store'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    table,

    opUser,
    agent,
    user,
    device,
    bill,
    bank,
    factory,
    app,
    store
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js